<template>
  <form @submit.prevent="submitChanges" class="col-12 mt-2 mx-auto">
    <!--Name-->
    <div class="form-group row">
      <label class="col-form-label col-2 text-lg-left text-left">Name</label>
      <div class="col-10">
        <input
          class="form-control form-control-lg form-control-solid"
          type="text"
          v-model="fullName"
        />
      </div>
    </div>

    <!-- Email -->
    <div class="form-group row">
      <label class="col-form-label col-2 text-lg-left text-left"
        >Email Address</label
      >
      <div class="col-10">
        <input
          type="email"
          class="form-control form-control-lg form-control-solid"
          v-model="email"
          placeholder="Email"
        />
      </div>
    </div>

    <!-- Show Errors -->
    <div class="form-group row">
      <template class="col" v-for="err in Object.keys(errors)">
        <p v-if="errors[err]" :key="'err-' + errors[err]" class="error">
          {{ errors[err] }}
        </p>
      </template>
    </div>

    <!--Save -->
    <div class="form-group row button-row">
      <button class="col">
        <span v-if="!loading">Save Changes</span>
        <Loader v-else />
      </button>
    </div>
  </form>
</template>

<script>
import axios from "axios";
import Loader from "@/components/Utils/Loader.vue";
import { mapState } from "vuex";
export default {
  name: "AccountTab",
  components: { Loader },
  data() {
    return {
      fullName: "",
      email: "",
      errors: {
        nameIsShort: false,
      },
      loading: false,
    };
  },

  computed: {
    ...mapState(["rep", "endpoint", "token"]),

    nameIsShort() {
      return this.fullName.length < 2;
    },

    hasNoErrors() {
      return !this.errors.nameIsShort;
    },
  },

  methods: {
    async submitChanges() {
      this.errors = {
        nameIsShort: false,
      };

      if (this.nameIsShort) {
        this.errors.nameIsShort =
          "Your name should be at least 2 characters long";
      }

      if (this.hasNoErrors && !this.loading) {
        const params = {
          full_name: this.fullName,
          email: this.email,
          api_token: this.token,
        };

        try {
          this.loading = true;
          const url = this.endpoint + "/profile";
          await axios.post(url, params);

          this.loading = false;
          this.$toastr.s("Your profile was updated!");
        } catch (error) {
          console.log(error);
          this.$toastr.e("There was an error");
          this.loading = false;
        }
      }
    },
  },

  watch: {
    rep() {
      this.fullName = this.rep.full_name;
      this.email = this.rep.email;
    },
  },

  mounted() {
    this.fullName = this.rep.full_name;
    this.email = this.rep.email;
  },
};
</script>
<style lang="scss" scoped>
form {
  display: flex;
  flex-direction: column;
  align-items: center;
}
p.error {
  background: rgb(252, 61, 61);
  color: whitesmoke !important;
  border-radius: 0 0 5px 6px;
  padding: 0.5rem;
  font-weight: bold;
  width: 100%;
  text-align: center;
  font-size: 1.1rem;
}
</style>